import gql from "graphql-tag";

const CREATE_TRUCK = gql`
  mutation createTruck($truck: TruckInput!) {
    createTruck(truck: $truck)
  }
`;

export default CREATE_TRUCK;
